import { useMutation } from '../../lib/hooks/useMutation'
import { AuthState } from './context'

export const useExtendUserSession = () => useMutation<AuthState>('/auth/extend')
